<template>
<div :class="[bgClass, borderClass, textClass, inline ? 'mb-16' : '']" class="flex items-center justify-between p-16">
    <div class="flex items-start gap-12 grow">
        <svg-icon :type="icon" :class="iconColor" />
        <div class="grow">
            <div v-if="oneLine">
                <p>
                <span v-if="bannerTitle || $slots.default" :class="[titleClass]">
                    <template v-if="bannerTitle && !$slots.default">
                        {{ bannerTitle }}
                    </template>
                    <slot />:
                </span>
                <span v-if="bannerBody && !$slots.description" v-html="bannerBody"></span>
                <slot name="description"/>
                </p>
            </div>
            <div v-else>
                <p v-if="bannerTitle || $slots.default" :class="[titleClass]">
                    <template v-if="bannerTitle && !$slots.default">
                        {{ bannerTitle }}
                    </template>
                    <slot />
                </p>
                <p v-if="bannerBody && !$slots.description" v-html="bannerBody"></p>
                <slot name="description"/>
            </div>
            <template v-if="link && !$slots.buttons">
                <a
                    v-if="!internalLink"
                    :href="bannerLink"
                    @click="!bannerLink ? $emit('click') : null"
                    target="_blank"
                    class="text-body-sm underline cursor-pointer flex items-center gap-4"
                >
                    {{ linkText ?? $t('general.learn_more') }}
                </a>
                <router-link
                    v-if="!$slots.buttons && internalLink"
                    :to="bannerLink"
                    class="text-body-sm underline cursor-pointer"
                >
                    {{ linkText ?? $t('general.learn_more') }}
                </router-link>
            </template>
            <template v-else-if="linkText && !$slots.buttons">
                <span
                @click="$emit('click')"
                class="text-body-sm underline cursor-pointer flex items-center gap-4">
                {{ linkText }}
                </span>
            </template>
            <div class="flex items-center justify-between w-full text-body-sm underline">
                <slot name="buttons" />
            </div>
        </div>
    </div>
    <button v-if="dismissible" @click="$emit('close')">
        <svg-icon type="cancel" :class="iconColor" />
    </button>
</div>
</template>
<script>
import SvgIcon from './SvgIcon.vue';
import SimpleButton from "./SimpleButton.vue";
export default {
    name: "Banner",
    components: {
        SimpleButton,
        'svg-icon': SvgIcon,
    },
    props: {
        content: Object,
        title: String,
        description: String,
        link:[String, Object],
        linkText: String,
        internalLink: Boolean,
        display: {
            type: String,
            validator: value => [
                'success',
                'info',
                'warning',
                'danger'
            ].includes(value),
        },
        success: Boolean,
        info: Boolean,
        warning: Boolean,
        danger: Boolean,
        dismissible: Boolean,
        inline: Boolean,
        oneLine: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            bgClasses: {
                success: 'bg-semantic-success-light',
                info: 'bg-semantic-info-light',
                warning: 'bg-semantic-warning-light',
                danger: 'bg-semantic-error-light',
            },
            borderClasses: {
                success: 'border-semantic-success',
                info: 'border-semantic-info',
                warning: 'border-semantic-warning',
                danger: 'border-semantic-error',
            },
            textClasses: {
                success: 'text-neutral-black',
                info: 'text-neutral-black',
                warning: 'text-neutral-black',
                danger: 'text-neutral-black',
            },
            titleClasses: {
                success: 'font-semibold',
                info: 'font-semibold',
                warning: 'font-semibold',
                danger: 'font-semibold',
            },
            icons: {
                success: 'check-circle-filled',
                info: 'info-filled',
                warning: 'warning-filled',
                danger: 'error-filled',
            },
            iconColors: {
                success: 'fill-semantic-success-dark',
                info: 'fill-semantic-info-dark',
                warning: 'fill-semantic-warning-dark',
                danger: 'fill-semantic-error-dark',
            }
        }
    },
    computed: {
        chosenDisplay() {
            if (this.display) {
                return this.display;
            } else {
                return this.success ? 'success' : this.info ? 'info' : this.warning ? 'warning' : this.danger ? 'danger' : 'info';
            }
        },
        bannerTitle() {
            if (this.title) {
                return this.title;
            } else if (this.content?.title) {
                return this.content.title;
            }
            return null;
        },
        bannerBody() {
            if (this.description) {
                return this.description;
            } else if (this.content?.body) {
                return this.content.body;
            }
            return null;
        },
        bannerLink() {
            if (this.link) {
                return this.link;
            } else if (this.content?.link) {
                return this.content.link;
            }
            return null;
        },
        bgClass() {
            return this.bgClasses[this.chosenDisplay];
        },
        borderClass() {
            let classes = this.borderClasses[this.chosenDisplay];
            if (this.inline) {
                classes += ' border-l-4 rounded-4';
            } else {
                classes += ' border-b-2';
            }
            return classes;
        },
        textClass() {
            return this.textClasses[this.chosenDisplay];
        },
        titleClass() {
            return this.titleClasses[this.chosenDisplay];
        },
        icon() {
            return this.icons[this.chosenDisplay];
        },
        iconColor() {
            return this.iconColors[this.chosenDisplay];
        }
    }
}
</script>
<style scoped>

</style>
